import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { InvoiceSaleService } from '../../inventory/sales/invoice-sale/invoice-sale.service';
import { jsPDF } from 'jspdf'
import autoTable, { Cell } from 'jspdf-autotable'
import { font } from './font';
import { TemplateService } from 'src/app/services/template.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { TemplateRequest } from 'src/app/models/template.model';
import { TemplateInvoice } from 'src/app/templateInvoice/templateInvoice';
import { InvoiceType } from 'src/app/enums/invoice-type.enum';

@Component({
	selector: 'app-edit-invoice',
	templateUrl: './edit-invoice.component.html',
	styleUrls: ['./edit-invoice.component.scss']
})
export class EditInvoiceComponent implements OnInit, AfterViewInit, OnDestroy {
	fcolor = "#563d7c";
	scolor = "#C8B7E1";
	tcolor = "#EDEAF0";
	company: any;
	warehouses = [];
	template = 1;
	loading = true;
	template4text: string = "";
	isLoaded = false;
	templateSvgs = [];
	testSvg = null;
	types = InvoiceType;
	inputs = {
		warehouse: {
			value: null,
			verified: false,
			required: false,
			message: 'Campo requerido',
			class: 'fa-list',
			color: 'danger',
			tooltip: 'status-warehouse',
			data: {
				id: null
			}
		}
	};
	filterWarehouses = [];
	timeout = null;
	loadingPreview: { [key: number]: boolean } = {}
	dataUrl = null;
	itemsPreview = 15;
	type: InvoiceType = InvoiceType.NORMAL;

	constructor(
		private authService: AuthenticationService,
		private saleService: InvoiceSaleService,
		private templateService: TemplateService,
		private toastService: ToastrService,
		private createService: TemplateInvoice
	) {
	}

	ngOnInit(): void {
		this.company = JSON.parse(this.authService.getCurrentCompany());
		this.start();
	}

	async start() {
		await this.cargarSVGsSecuencialmente();
		this.saleService.getWarehouses().subscribe({
			next: (response: ResponseObject) => {
				this.warehouses = response.data;
				this.filterWarehouses = this.warehouses;
				if (this.filterWarehouses.length == 1) {
					var assigned = this.filterWarehouses[0];
					this.inputs.warehouse.value = assigned.name;
					this.inputs.warehouse.data = assigned;
					this.inputs.warehouse.class = "fa-check";
					this.inputs.warehouse.verified = true;
					this.showWarehousePreferences(this.filterWarehouses[0]);
				} else {
					this.previewTemplate();
				}
			},
			error: (error: HttpErrorResponse) => {
				this.changeColor('primary');
				this.changeColor('secondary');
				this.changeColor('tertiary');
				this.toastService.error(error.error.message);
			}
		})
	}

	saveTemplate() {
		var selected = this.inputs.warehouse.data;
		var templateRequest = new TemplateRequest(this.fcolor, this.scolor, this.tcolor, this.template, selected['name'], selected.id);
		this.templateService.saveEditableInfo(templateRequest).subscribe({
			next: (response: ResponseObject) => {
				this.toastService.success("Se guardo la configuración correctamente!");
			},
			error: (error: HttpErrorResponse) => {
				this.toastService.error(error.error.message);
			}
		})
	}

	showWarehousePreferences(warehouse: any) {
		this.fcolor = (warehouse.fcolor) ? warehouse.fcolor : "#563d7c";
		this.scolor = (warehouse.scolor) ? warehouse.scolor : "#C8B7E1";
		this.tcolor = (warehouse.tcolor) ? warehouse.tcolor : "#ecebf4";
		this.template = (warehouse.nfact) ? warehouse.nfact : 1;
		this.changeColor('primary');
		this.changeColor('secondary');
		this.changeColor('tertiary');
		this.previewTemplate();
	}

	verifiedInput(warehouseSelected: any) {
		var inputValue = warehouseSelected.target.value;
		clearTimeout(this.timeout);
		this.saleService.getWarehouseByClue(inputValue).subscribe({
			next: (response: ResponseObject) => {
				this.warehouses = response.data;
				this.filterWarehouses = this.warehouses;
				if (this.filterWarehouses.length == 1) {
					this.inputs.warehouse.class = "fa-check";
					this.inputs.warehouse.value = this.filterWarehouses[0].name;
					this.inputs.warehouse.verified = true;
					this.inputs.warehouse.data = this.filterWarehouses[0];
					this.showWarehousePreferences(this.filterWarehouses[0]);
				} else {
					this.inputs.warehouse.class = "fa-xmark";
					this.inputs.warehouse.verified = false;
					this.inputs.warehouse.data = null;
				}
			},
			error: (error: HttpErrorResponse) => {
				this.inputs.warehouse.class = "fa-xmark";
				this.toastService.error(error.error.message);
				this.inputs.warehouse.verified = false;
				this.inputs.warehouse.data = null;
			}
		});
	}

	handleInput(warehouseSelected: any) {
		var inputValue = warehouseSelected.target.value;
		clearTimeout(this.timeout);
		this.inputs.warehouse.class = "typing";
		this.timeout = setTimeout(() => {
			this.saleService.getWarehouseByClue(inputValue).subscribe({
				next: (response: ResponseObject) => {
					this.warehouses = response.data;
					this.filterWarehouses = this.warehouses;
					if (this.filterWarehouses.length > 0) {
						this.inputs.warehouse.class = "bx bx-list-check";
						this.inputs.warehouse.verified = false;
						this.inputs.warehouse.data = null;
					} else {
						this.inputs.warehouse.class = "fa-xmark";
						this.inputs.warehouse.verified = false;
						this.inputs.warehouse.data = null;
					}
				},
				error: (error: HttpErrorResponse) => {
					this.inputs.warehouse.class = "fa-xmark";
					this.inputs.warehouse.verified = false;
					this.inputs.warehouse.data = null;
					this.toastService.error(error.error.message);
				}
			});
		}, 1000);
	}

	changeStatusInput(warehouseSelected: any) {
		this.inputs.warehouse.data = warehouseSelected;
		this.inputs.warehouse.value = warehouseSelected.name;
		this.inputs.warehouse.class = "fa-check";
		this.inputs.warehouse.verified = true;
		this.showWarehousePreferences(this.filterWarehouses[0]);
	}

	async cargarSVG(templateId: string, containerId: string): Promise<void> {
		try {
			const svgDocument = await this.templateService.getSvg(templateId).toPromise();
			const svgElement = svgDocument.documentElement;
			const container = document.getElementById(containerId) as any;
			container.appendChild(svgElement);
			this.templateSvgs.push(svgElement);
		} catch (error) {
			console.error('Error cargando el archivo SVG', error);
		}
	}

	async getSVG(templateId: string): Promise<void> {
		try {
			const svgDocument = await this.templateService.getSvg(templateId).toPromise();
			const svgElement = svgDocument.documentElement;
			this.testSvg = svgElement;
		} catch (error) {
			this.toastService.error("Error al obtener el formato");
		}
	}

	async cargarSVGsSecuencialmente() {
		await this.cargarSVG.call(this, 'template1v1', 'template1-container');
		await this.cargarSVG.call(this, 'template4v2', 'template4-container');
		await this.cargarSVG.call(this, 'template5v1', 'template5-container');
		await this.cargarSVG.call(this, 'template6v1', 'template6-container');
		this.changeColor('primary');
		this.changeColor('secondary');
		this.changeColor('tertiary');
		this.isLoaded = true;
	}

	ngAfterViewInit(): void {
		this.saleService.getWarehouses().subscribe(
			(response) => {
				this.warehouses = Object(response)['data'];
				if (this.warehouses.length > 0) {
					this.loading = false;
				}
			},
			(error) => {

			});
	}

	previewTemplate() {
		this.loadingPreview[this.template] = true;
		var configurationInvoice = {
			id: this.template,
			fcolor: this.fcolor,
			scolor: this.scolor,
			tcolor: this.tcolor,
			slogan: "Un slogan"
		};
		this.createService.isLoading = this.loadingPreview;
		this.createService.visor = document.getElementById('visor');
		var ticketData = this.createService.dataDefault(this.itemsPreview);
		ticketData.type = this.type;
		this.createService.selectTemplate(configurationInvoice, ticketData, 'preview');
	}
	
	ngOnDestroy(): void {
		this.createService.visor = null;
	}

	selectTemplate(template) {
		if (this.template == template) {
			return;
		}
		this.template = template;
		if (template < 7){
			this.previewTemplate();
		} else {
			this.downloadTicket();
		}
	}

	changeColor(type) {
		var color;
		color = type == 'primary' ? this.fcolor : this.scolor;
		color = type == 'tertiary' ? this.tcolor : color;
		var colors = document.getElementsByClassName(type + "-color");
		var colors_circle = document.getElementsByClassName(type + '-color-circle');
		for (let i = 0; i < colors.length; i++) {
			const element = colors[i] as any;
			element.style.fill = color;
			element.style.color = color;
		}
		for (let i = 0; i < colors_circle.length; i++) {
			const element = colors_circle[i] as any;
			element.style.stroke = color;
		}
	}

	getContrastColor(hexColor: string): string {
		// Convertir el código hexadecimal a valores RGB
		const r = parseInt(hexColor.slice(1, 3), 16);
		const g = parseInt(hexColor.slice(3, 5), 16);
		const b = parseInt(hexColor.slice(5, 7), 16);

		// Calcular el brillo relativo del color (Luminance)
		const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

		// Determinar si el color de fondo es oscuro o claro y devolver un color de contraste adecuado
		return luminance > 0.5 ? '#000000' : '#ffffff';
	}

	hideElements(hides: any) {
		for (let i = 0; i < hides.length; i++) {
			const element = hides[i];
			element.innerHTML = "";
		}
	}

	downloadTicket(){
		var ticketData = this.createService.dataDefault(this.itemsPreview);
		ticketData.type = this.type;
		this.createService.visor = document.getElementById('visor');
		this.createService.ticket(ticketData, null);
	}

	changeColorType(type: string, color: any, element: any) {
		var colors = element.getElementsByClassName(type + "-color");
		var colors_circle = element.getElementsByClassName(type + '-color-circle');
		for (let i = 0; i < colors.length; i++) {
			const element = colors[i] as any;
			element.style.fill = color;
			element.style.color = color;
		}
		for (let i = 0; i < colors_circle.length; i++) {
			const element = colors_circle[i] as any;
			element.style.stroke = color;
		}
	}
}
